module.exports = __webpack_public_path__ + "img/bobines.8c8ff279.jpg";